import { stripAppBasePrefix } from "@shared/utils/url/toAppUrl";
import { AppPaths } from "./paths";

/** Путь по умолчанию после успешного входа. */
export const DEFAULT_POST_AUTH_PATH = AppPaths.MENU;

const BLOCKED_REDIRECT_PATHS = new Set([AppPaths.AUTH, AppPaths.ROOT, ""]);
const PROTOCOL_RE = /^[a-z][a-z0-9+.-]*:/i;

/** Возвращает origin приложения для проверки same-origin redirect. */
function getAppOrigin(): string {
    return typeof window === "undefined" ? "http://localhost" : window.location.origin;
}

/**
 * Проверяет наличие управляющих символов, которые могут менять разбор URL.
 * @param value проверяемая строка
 */
function hasControlChars(value: string): boolean {
    return Array.from(value).some((char) => {
        const code = char.charCodeAt(0);
        return code <= 31 || code === 127;
    });
}

/**
 * Проверяет безопасность внутреннего redirect path.
 * @param path декодированное значение query `redirect`
 */
export function isSafeInternalRedirectPath(path: string): boolean {
    if (path.trim() !== path) {
        return false;
    }
    if (hasControlChars(path)) {
        return false;
    }
    if (!path.startsWith("/")) {
        return false;
    }
    if (path.startsWith("//")) {
        return false;
    }
    if (path.includes("\\")) {
        return false;
    }
    if (PROTOCOL_RE.test(path)) {
        return false;
    }
    try {
        const url = new URL(path, getAppOrigin());
        const normalizedPath = `${url.pathname}${url.search}${url.hash}`;

        if (url.origin !== getAppOrigin()) {
            return false;
        }
        if (normalizedPath !== path) {
            return false;
        }
        if (BLOCKED_REDIRECT_PATHS.has(url.pathname)) {
            return false;
        }
    } catch {
        return false;
    }
    return true;
}

/**
 * Возвращает путь для навигации после login. \
 * Снимает Vite `base` с пути (`/mobile/menu` → `/menu`), чтобы `navigate` не удваивал basename.
 * @param redirectFromQuery сырое значение query `redirect` или `null`
 */
export function resolvePostAuthRedirectPath(redirectFromQuery: string | null): string {
    if (redirectFromQuery == null) {
        return DEFAULT_POST_AUTH_PATH;
    }

    try {
        const decoded = stripAppBasePrefix(decodeURIComponent(redirectFromQuery));
        if (isSafeInternalRedirectPath(decoded)) {
            return decoded;
        }
        return DEFAULT_POST_AUTH_PATH;
    } catch {
        return DEFAULT_POST_AUTH_PATH;
    }
}
